import { render, staticRenderFns } from "./SickLeaveOptionsModal.vue?vue&type=template&id=1154ae90&scoped=true&"
import script from "./SickLeaveOptionsModal.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveOptionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154ae90",
  null
  
)

export default component.exports